<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="noindent1"><em class="italic">The numerals appearing at the foot of each excerpt indicate the date of the respective paper or speech</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Editornote.vue?4b44d6bc